import CryptoJS from 'crypto-js';
export default {
	/**
	 * 加密
	 */
	set(data,key='qwsdefghyjygrfed') {
		let vbvb = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(key), {
            mode: CryptoJS.mode.CBC,
            iv: CryptoJS.enc.Utf8.parse('mncbgdhujhgtserx'),
            padding: CryptoJS.pad.Pkcs7
        }).toString();
		let sss = {
			0:vbvb,
			page:data.page?data.page:null,
		};
		return sss;
	},

	/**
	 *  解密
	 */
	get(word, key) {
		if (!word) {
			return word
		}
		let www = JSON.parse(word)
		const encryptedData = www[0]; // 后端返回的加密数据
		const iv = www[1]; // 后端返回的初始化向量（IV）
		const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedData);
		const ivBytes = CryptoJS.enc.Base64.parse(iv);
		// 解密数据
		key = key || 'aqitaibookwebasd'
		const key1 = CryptoJS.enc.Utf8.parse(key); // 密钥
		const decryptedData = CryptoJS.AES.decrypt({ ciphertext: encryptedBytes }, key1, { iv: ivBytes });
		const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
		return JSON.parse(decryptedText);
	}
}
